import React, { useEffect, useState } from 'react'
import Popup from '../../Components/Popup'
import { CheckValidation } from '../../Components/Validations';
import { ApiGetCall, ApiGetCallAuthKey, ApiPostCall } from '../../JS/Connector';
import AlertsComp from '../../Components/AlertsComp';
import { LogInSchoolID } from '../../JS/Common';
import useConfig from '../../Hooks/useConfig';

export default function RoleModel(props) {
    const { is_enterprise, show_shop, dcc_module_text } = useConfig();
    const [roleName, setRoleName] = useState('');
    const [roleId, setRoleId] = useState('');
    const [checkedItems, setCheckedItems] = useState({});
    const [accessRoleError, setAccessRoleError] = useState('');
    const [viewData, setViewData] = useState([]);
    const [tech_report_checked, setTech_report_checked] = useState(0);
    useEffect(() => {
        async function GetAllRoles() {
            props.setLoading(true);
            await ApiGetCall(`/roles/edit-data?uuid=${props.roleId}&schoolId=${LogInSchoolID}`).then((result) => {
                if (result == undefined || result == "") {
                    alert("Something went wrong");
                } else {
                    const responseRs = JSON.parse(result);
                    props.setLoading(false);
                    setViewData(responseRs);
                    if (props.flag == 2) {
                        setRoleName(responseRs.access);
                        setRoleId(responseRs.access_id);
                        setTech_report_checked(responseRs.school_tech_report);
                        let selectedMenus = {};
                        responseRs?.all_menus_with_selection?.forEach((menu) => {
                            if (menu.selected) {
                                selectedMenus[menu.menu_id] = {
                                    submenu: [],
                                    orderId: menu.order_id || null
                                };

                                if (menu?.sub_menu_details?.length > 0) {
                                    selectedMenus[menu.menu_id].submenu = menu.sub_menu_details
                                        .filter(sub => sub.selected)
                                        .map(sub => sub.id);
                                }
                            }
                        });

                        setCheckedItems(selectedMenus);
                    }
                }
            });
        }
        GetAllRoles();
    }, []);
    const handleMenuChange = (menuId) => {
        setCheckedItems((prevState) => {
            const newState = prevState ? { ...prevState } : {};

            const menuData = viewData?.all_menus_with_selection?.find(item => item.menu_id === menuId);

            if (!newState[menuId]) {
                newState[menuId] = {
                    submenu: [],
                    orderId: menuData?.order_id || null
                };
            } else {
                delete newState[menuId];
            }

            return newState;
        });
    };
    const handleSubMenuChange = (menuId, submenuId) => {
        setCheckedItems((prevState) => {
            // Ensure prevState is always an object
            const newState = prevState ? { ...prevState } : {};

            // Ensure the menuId exists before modifying submenu
            if (!newState[menuId]) {
                newState[menuId] = { submenu: [], orderId: null };
            }

            const submenuData = viewData?.all_menus_with_selection
                ?.find(item => item.menu_id === menuId)
                ?.sub_menu_details?.find(sub => sub.id === submenuId);

            // Toggle submenu selection
            if (newState[menuId].submenu.includes(submenuId)) {
                newState[menuId].submenu = newState[menuId].submenu.filter(id => id !== submenuId);
            } else {
                newState[menuId].submenu.push(submenuId);
            }

            // Remove parent menu if no submenu is left
            if (newState[menuId].submenu.length === 0) {
                delete newState[menuId];
            } else {
                newState[menuId].orderId = submenuData?.order_id || newState[menuId].orderId;
            }

            return newState;
        });
    };
    const Addmodalbody = (
        <div className='row parent' id="roleDivId">
            <div className='col-12'>
                <div className='col-12 text-start px-1 pb-1 shipdevice-font-style'>Role Name<label className='redText'>*</label></div>
                <input className="form-control" type="text" required name={`rolename`} value={roleName}
                    onChange={(e) => setRoleName(e.target.value)} placeholder={`Enter Role Name`}
                />
                <span className="form-text invalid-feedback">
                    *required
                </span>
            </div>
            <div className='col-12 pt-2 ps-4'>
                <input
                    className="form-check-input me-2"
                    type="checkbox"
                    onChange={(e) => setTech_report_checked(e.target.checked == true ? 1 : 0)}
                    checked={tech_report_checked == 1}
                />
                <label>Included in Technician Reports?</label>
            </div>
            <div className='col-12 pt-3'>
                <div className='col-12 text-start px-1 pb-1 shipdevice-font-style'>Select Tabs<label className='redText'>*</label></div>
                {viewData?.all_menus_with_selection?.length ?
                    viewData?.all_menus_with_selection?.filter((item) => {
                        if (is_enterprise && item.menu === dcc_module_text) {
                            return false;
                        }
                        if (item.menu === "Shop" && !show_shop) {
                            return false;
                        }
                        return true;
                    })?.map((item, i) => {
                        return <div className="form-check-label py-1 font-13 ps-4" key={i}>
                            {item?.sub_menu_details?.length > 0 ?
                                <li>{item.menu}</li>
                                :
                                <>
                                    <input
                                        className="form-check-input me-2"
                                        type="checkbox"
                                        onChange={() => handleMenuChange(item.menu_id)}
                                        checked={!!checkedItems[item.menu_id]}
                                    />
                                    <label>{item.menu}</label>
                                </>
                            }

                            {item?.sub_menu_details?.length > 0 &&
                                <div className='col-12'>
                                    {item?.sub_menu_details?.filter((submenu) => submenu.name != "Users Groups")?.map((submenu, k) => {
                                        return <div key={k} className='ps-4'>
                                            <input className='form-check-input me-2'
                                                type='checkbox'
                                                onChange={() => handleSubMenuChange(item.menu_id, submenu.id)}
                                                checked={checkedItems[item.menu_id]?.submenu.includes(submenu.id)}
                                            />
                                            {submenu.name}
                                        </div>
                                    })}

                                </div>
                            }
                        </div>

                    })
                    :
                    '-'

                }
                <span className="Emailinvalid">
                    {accessRoleError}
                </span>
            </div>


        </div>
    );
    const modalbody = (
        <div className='row parent' id="roleDivId">
            <div className='col-12'>
                <div className='col-12 text-start px-1 pb-1 shipdevice-font-style'>Role Name<label className='redText'>*</label></div>
                <input className="form-control" type="text" required name={`rolename`} value={roleName}
                    onChange={(e) => setRoleName(e.target.value)} placeholder={`Enter Role Name`}
                />
                <span className="form-text invalid-feedback">
                    *required
                </span>
            </div>
            <div className='col-12 pt-2 ps-4'>
                <input
                    className="form-check-input me-2"
                    type="checkbox"
                    onChange={(e) => setTech_report_checked(e.target.checked == true ? 1 : 0)}
                    checked={tech_report_checked == 1}
                />
                <label>Included in Technician Reports?</label>
            </div>
            <div className='col-12 pt-3'>
                <div className='col-12 text-start px-1 pb-1 shipdevice-font-style'>Select Tabs<label className='redText'>*</label></div>
                {viewData?.all_menus_with_selection?.length ?
                    viewData?.all_menus_with_selection?.filter((item) => {
                        if (is_enterprise && item.menu === dcc_module_text) {
                            return false;
                        }
                        if (item.menu === "Shop" && !show_shop) {
                            return false;
                        }
                        return true;
                    })?.map((item, i) => {
                        return <div className="form-check-label py-1 font-13 ps-4" key={i}>
                            {item?.sub_menu_details?.length > 0 ?
                                <li>{item.menu}</li>
                                :
                                <>
                                    <input
                                        className="form-check-input me-2"
                                        type="checkbox"
                                        onChange={() => handleMenuChange(item.menu_id)}
                                        checked={!!checkedItems[item.menu_id]}
                                    />
                                    <label>{item.menu}</label>
                                </>
                            }

                            {item?.sub_menu_details?.length > 0 &&
                                <div className='col-12'>
                                    {item?.sub_menu_details?.filter((submenu) => submenu.name != "Users Groups")?.map((submenu, k) => {
                                        return <div key={k} className='ps-4'>
                                            <input className='form-check-input me-2'
                                                type='checkbox'
                                                onChange={() => handleSubMenuChange(item.menu_id, submenu.id)}
                                                checked={!!checkedItems[item.menu_id]?.submenu?.includes(submenu.id)}
                                            />
                                            {submenu.name}
                                        </div>
                                    })}

                                </div>
                            }
                        </div>

                    })
                    :
                    '-'

                }
                <span className="Emailinvalid">
                    {accessRoleError}
                </span>
            </div>

        </div>
    );
    const viewmodalbody = (
        <div className='row font-13'>
            <div className='col-12'>
                <b>Role : </b>{viewData.access}
            </div>
            <div className='col-12 pt-2'>
                <b>Tabs Access : </b>
                {viewData?.all_menus_with_selection?.length ?
                    <ul>
                        {viewData?.all_menus_with_selection?.filter((item) => {
                            if (is_enterprise && item.menu === dcc_module_text) {
                                return false;
                            }
                            if (item.menu === "Shop" && !show_shop) {
                                return false;
                            }
                            return true;
                        })?.map((item, i) => {
                            return item.selected == true &&
                                <li key={i} className='py-1'>
                                    {item.menu}
                                    {item?.sub_menu_details?.length > 0 &&
                                        <ul>
                                            {item?.sub_menu_details?.filter((submenu) => submenu.name != "Users Groups")?.map((submenu, k) => {
                                                return submenu.selected == true &&
                                                    <li key={k}>
                                                        {submenu.name}
                                                    </li>
                                            })}

                                        </ul>
                                    }
                                </li>

                        })}
                    </ul>
                    :
                    '-'

                }
            </div>
        </div>
    )
    const handleSaveRole = async () => {
        var isFormValid = CheckValidation({ formID: 'roleDivId' });
        const hasCheckedItems = Object.keys(checkedItems).length > 0;

        if (!hasCheckedItems) {
            setAccessRoleError('* At least one menu or submenu must be selected.');
            isFormValid = false;
        } else {
            setAccessRoleError('');
        }
        if (!isFormValid) return;
        props.setLoading(true);
        const checkedData = Object.entries(checkedItems).map(([menuId, value]) => {
            const parentMenu = viewData?.all_menus_with_selection?.find(menu => menu.menu_id == menuId);

            const orderId = value.submenu.length > 0 ? parentMenu?.order_id || null : value.orderId;

            return {
                menuId: menuId,
                submenuIds: value.submenu,
                orderId: orderId
            };
        });
        const allMenusData = viewData?.all_menus_with_selection?.map(menu => ({
            menuId: menu.menu_id,
            submenuIds: menu.sub_menu_details
                ? menu.sub_menu_details.map(submenu => ({
                    id: submenu.id,
                    selected: checkedItems[menu.menu_id]?.submenu.includes(submenu.id) || false
                }))
                : [],
            selected: checkedItems.hasOwnProperty(menu.menu_id),
            orderId: checkedItems[menu.menu_id]?.submenu.length > 0 ? menu.order_id : checkedItems[menu.menu_id]?.orderId
        }));

        const raw = JSON.stringify({
            roleName: roleName,
            menus: props.flag == 1 ? checkedData : allMenusData,
            roleId: props.flag == 1 ? null : roleId,
            addEditFlag: props.flag,
            techReportChecked: tech_report_checked,
            schoolId: LogInSchoolID
        });
        await ApiPostCall("/roles/save", raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                props.setLoading(false);
                const responseRs = JSON.parse(result);
                if (responseRs.status == "success") {
                    var msg = props.flag == 1 ? "New Role Added Successfully." : 'Role Updated Successfully.';
                    props.setAlerts(<AlertsComp show={true} variant="success" msg={msg} />);
                    props.closepopup();
                    setTimeout(() => {
                        props.setAlerts(<AlertsComp show={false} />);
                        props.GetAllRoles();
                    }, 1500);
                }
                else {
                    props.setAlerts(<AlertsComp show={true} variant="danger" msg={responseRs?.msg} />);
                    setTimeout(() => {
                        props.setAlerts(<AlertsComp show={false} />);
                    }, 2000);
                }
            }
        });
    }
    return (
        <div>
            <Popup isshow={props.isShow} size={"md"} title={`${props.flag == 1 ? 'Add Role' : props.flag == 2 ? 'Edit Role' : 'View Role Details'}`}
                closePopup={(e) => props.closepopup()} modalBody={props.flag == 1 ? Addmodalbody : props.flag == 3 ? viewmodalbody : modalbody} visibleSaveBtn={props.flag == 3 ? false : true}
                handleSave={handleSaveRole} btnText={props.flag == 1 ? "Save" : "Update"} />
        </div>
    )
}
